import { render, staticRenderFns } from "./tmDeliveryInfo.vue?vue&type=template&id=02cb42fe"
import script from "./tmDeliveryInfo.vue?vue&type=script&lang=js"
export * from "./tmDeliveryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports